import _ from 'lodash';
import {STATES} from 'common/domain/states';
import {
  LOANS,
  LOANS_MODAL_STATES,
  LOANS_MY_LOANS_MODAL_COACHMARK_CONFIG
} from 'loans.module/common/domain/constants.loans';
import {MODALS, EVENTS} from 'common/domain/constants';

const CONTEXT_MENU_TAG = 'my-loans-context-menu';
const VIEW_OPTIONS_TAG = '.view-options';

class MyLoansController {
  constructor
  ($log,
   $timeout,
   $window,
   $state,
   $rootScope,
   $translate,
   LoansUserDataService,
   myLoansService,
   LoansOperationsService,
   LoansStatesService,
   GoBackDataService,
   $q,
   loadingMobileService) {
    'ngInject';
    this.log = $log;
    this.timeout = $timeout;
    this.window = $window;
    this.state = $state;
    this.rootScope = $rootScope;
    this.translate = $translate;
    this.loansUserDataService = LoansUserDataService;
    this.myLoansService = myLoansService;
    this.loansOperationsService = LoansOperationsService;
    this.loansStatesService = LoansStatesService;
    this.goBackDataService = GoBackDataService;
    this.q = $q;
    this.loadingMobileService = loadingMobileService;
    this.loaded = false;
    this.myLoans = [];

    this.coachmarkData = LOANS_MY_LOANS_MODAL_COACHMARK_CONFIG;

    this.userId = this.loansUserDataService._employee.userId;

    this.isMobileApp = $window.innerWidth < 1024;

    this.objectStatesFilter = this.loansStatesService.statesFilters;

    this.setTitlePage();
  }

  $onInit() {

    this.selectedFilterStatus = '';
    this.getMyLoans();
    this.hideContextMenuAfterClickOutside();

  }

  setTitlePage() {
    this.rootScope.$broadcast(EVENTS.CHANGE_TITLE, {title: 'LOANS.MY_LOANS.TITLE'});
  }

  getModal(item) {
    const availableModals = {
      cadastral: $(MODALS.REQUEST_CADASTRAL),
      myLoans: $(MODALS.MY_LOANS)
    };

    return availableModals[item];
  }

  getMyLoans() {
    this.modalExists = false;
    this.loadingMobileService.show();
    this
      .myLoansService
      .getMyLoans(this.userId)
      .then(myLoans => {
        this.myLoans = myLoans;
        this.initContextMenuViewOptions(this.myLoans);
        this.setLinks(this.myLoans);
        this.modalExists = true;
      }, error => {
        this.log.error(error);
        this.errorMyLoans = true;
      })
      .finally(() => {
        this.loaded = true;
        this.loadingMobileService.hide();
      });
  }

  getClasses() {
    return {
      'responsiveMobile': this.isMobileApp,
    };
  }

  showLoading() {
    return !this.isMobileApp && !this.loaded;
  }

  myLoansAvailable() {
    return this.myLoans.length > 0 && this.loaded;
  }

  showEmptyMessage() {
    return this.myLoans.length === 0 && this.loaded;
  }

  initContextMenuViewOptions(loans) {
    loans.forEach((loan) => loan.viewOptions = false);
  }

  setLinks(loans) {
    loans.forEach(this.setLoanLinks, this);
  }

  setLoanLinks(loan) {
    const links = LOANS.LINKS;

    loan.links = {
      receipts: `${links.RECEIPTS}?id=${loan.identifying}&matricula=${this.userId}`,
      policy: `${links.POLICY}?id=${loan.identifying}&matricula=${this.userId}`,
      tax: `${links.TAX}?id=${loan.identifying}&matricula=${this.userId}`,
    };
  }

  filterByStatus($event) {
    this.selectedFilterStatus = $event.status;
    this.filterActive = $event.filterActive;
  }

  onToggleOptions($event) {
    const showAfterHide = !$event.loan.viewOptions;
    this.initContextMenuViewOptions(this.myLoans);
    $event.loan.viewOptions = showAfterHide;
  }

  hideContextMenuAfterClickOutside() {
    $(document).click(event => {
      const target = $(event.target);
      const clickOutsideOfViewOptions = !target.closest(VIEW_OPTIONS_TAG).length;
      const clickOutsideOfMenu = !target.closest(CONTEXT_MENU_TAG).length;
      if (clickOutsideOfViewOptions && clickOutsideOfMenu) {
        this.timeout(() => this.initContextMenuViewOptions(this.myLoans));
      }
    });
  }

  onChangeOptionSelected($event) {
    this.optionIsSelected = $event.optionSelected;
    this.resetForm = true;

    if (!_.isEmpty(this.loanObjectModal.cadastralReference)) {
      this.resetForm = false;
    }

    if (this.isMobileApp && $event.dataCadastral) {
      let dataEvent = ($event.dataCadastral) ? $event.dataCadastral : $event;
      let dataCadastral = {
        loan: dataEvent.loan || this.loanObjectModal,
        tempLoanObject: dataEvent.tempLoanObject || this.tempLoanObject,
        optionIsSelected: $event.optionIsSelected,
        from: 'my-loans',
      };

      this.state.go(STATES.LOANS.CADASTRAL_REFERENCE, {dataParams: dataCadastral});
    }
  }

  onSelectOption($event) {
    this.loanObjectModal = $event.loan;
  }

  onSave($event) {
    this.hideModal();
    this.error = $event.error;
    this.messageError = $event.messageError;
    this.getModal('cadastral').modal('show');
    this.getMyLoans();
  }

  showCadastralReference() {
    if (this.isMobileApp) {
      let paramsToCadastral = {
        loan: this.loanObjectModal,
        tempLoanObject: this.tempLoanObject,
        from: 'my-loans',
      };
      this.hideModal();
      return this.state.go(STATES.LOANS.CADASTRAL_REFERENCE, {dataParams: paramsToCadastral});
    }

    this.optionIsSelected = LOANS_MODAL_STATES.CADASTRAL_REFERENCE;
  }

  closeModalCadastral($event) {
    if (!$event.isCadastralCorrect) {
      this.tempLoanObject = $event.cadastralReference;
      this.optionIsSelected = LOANS_MODAL_STATES.CLOSE_CADASTRAL_REFERENCE;
      this.getModal('myLoans').modal('show');
    } else {
      this.optionIsSelected = '';
      this.hideModal();
    }
  }

  hideModal() {
    this.getModal('myLoans').modal('hide');
  }

  checkCloseModalCadastral() {
    return !_.isEmpty(this.loanObjectModal.cadastralReference);
  }

  resetFormCadastral() {
    if (this.resetForm || !this.isCadastralCorrect) {
      this.loanObjectModal.cadastralReference = {};
      this.tempLoanObject = {};
      this.hideModal();
    }
  }
}

export default MyLoansController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoans.controller.js